<template>
  <div>


        <van-tabbar v-model="active">
          <van-tabbar-item name="servis" to="/servis" icon="wap-home-o">Servis</van-tabbar-item>
          <van-tabbar-item name="detay" :to="`/servis/${id}`" icon="home-o">Genel</van-tabbar-item>
          <van-tabbar-item name="islem" :to="`/islem/${id}`" icon="notes-o">İşlem</van-tabbar-item>
          <van-tabbar-item name="stok" :to="`/stok/${id}`" icon="points">Stok</van-tabbar-item>
          <van-tabbar-item name="matbuu" :to="`/matbuu/${id}`" icon="photo-o">Matbuu</van-tabbar-item>
          <van-tabbar-item name="cihaz" :to="`/cihaz/${id}`" icon="fire-o">Cihaz</van-tabbar-item>
        </van-tabbar>
        <van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant';

export default {
  data() {
    return {
      id:this.$route.params.id,
      loading:false,
      finished:false,
      list:[],
      error:[],
      donem: this.$request.donem(),
      active:'konum',
      activeName: 'genel',
      show:true
    };
  },
  created(){
 // this.getPostsAsync()
  },
  methods: {



  },
 
};
</script>


// WEBPACK FOOTER //
// src/components/servis/konum.vue